module.exports = __webpack_public_path__ + "media/images/font/TradeGothicNextLTPro-BdCn-d9c3765e1c7616df00da3959dac81ba2.woff2";